import { urlHelper } from 'src/app/helpers';
import { apiSlice } from 'src/app/redux/api/apiSlice';
import { LocationInterestLookupDataType } from 'src/app/services/interest/interest.service.type';
import { LocationRecognizedResultType } from 'src/app/services/interest/Location/location-service.type';
import { finalUrlsConfig } from 'src/configs/url.config';

export const locationRecognizedSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getLocationsRecognized: builder.query<LocationRecognizedResultType, LocationInterestLookupDataType | void>({
      query: (params?: LocationInterestLookupDataType) => ({
        url: finalUrlsConfig().interest.recognized.location,
        params: urlHelper.getLookupQuery(params),
      }),
      transformResponse: (data: LocationRecognizedResultType) => {
        const filtered = data.rows.filter((row) => !row.name.includes('Unknown '));
        return {
          count: filtered.length,
          rows: filtered,
        };
      },
      providesTags: (result) =>
        result
          ? [
              ...result.rows.map(({ id }) => ({
                type: 'LocationRecognized' as const,
                id,
              })),
              { type: 'LocationRecognized', id: 'LIST' },
            ]
          : [{ type: 'LocationRecognized', id: 'LIST' }],
    }),
  }),
});

export const { useGetLocationsRecognizedQuery, useLazyGetLocationsRecognizedQuery } = locationRecognizedSlice;
